/* ============================================================
   AURAS — scroll reveal global
   Marca elementos de secciones conocidas y los anima al entrar
   en pantalla, en cascada. Una sola vez por elemento.
   ============================================================ */
(function(){
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  /* Contenedores cuyos hijos directos entran en cascada */
  var GROUPS = [
    '.astat__in',        /* barra de stats */
    '.abft__grid',       /* tarjetas de beneficios */
    '.afeat__grid',      /* grid de productos */
    '.afeat__scroll',    /* carrusel de productos */
    '.avid__row'         /* fila de videos UGC */
  ];

  /* Elementos sueltos que entran solos */
  var SINGLES = [
    '.abft__kicker',
    '.aus__block'
  ];

  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (!entry.isIntersecting) return;
      entry.target.classList.add('au-in');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });

  function prep(el, index){
    if (el.classList.contains('au-rv')) return;
    el.classList.add('au-rv');
    if (index > 0 && index <= 6) el.classList.add('au-d' + index);
    observer.observe(el);
  }

  function scan(){
    GROUPS.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(group){
        Array.prototype.forEach.call(group.children, function(child, i){
          prep(child, Math.min(i + 1, 6));
        });
      });
    });
    SINGLES.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){ prep(el, 1); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* El editor del tema recarga secciones sin recargar la pagina */
  document.addEventListener('shopify:section:load', function(){ setTimeout(scan, 60); });
})();
